import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { SurfaceDefect } from "../models/Inspection";

export const getSurfaceDefects = async (
	params: { includeInactive?: boolean } = {},
	signal?: AbortSignal,
): Promise<SurfaceDefect[]> => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "IncludeInactive", value: params.includeInactive ?? false },
	];

	const resp = await apiService.callV2(
		"[M1].[GetSurfaceDefects]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as SurfaceDefect[];
	} else {
		throw new Error(resp.message || "Error fetching surface defects");
	}
};

export const upsertSurfaceDefect = async (surfaceDefect: SurfaceDefect) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "SurfaceDefectId", value: surfaceDefect.SurfaceDefectId },
		{ name: "SurfaceDefectName", value: surfaceDefect.SurfaceDefectName },
		{ name: "Color", value: surfaceDefect.Color },
	];

	const resp = await apiService.callV2(
		"[M1].[UpsertSurfaceDefect]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.returnValue", null) as number;
	} else {
		throw new Error(resp.message || "Error saving the surface defect");
	}
};

export const deleteSurfaceDefect = async (surfaceDefectId: number | null) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "SurfaceDefectId", value: surfaceDefectId },
	];

	const resp = await apiService.callV2(
		"[M1].[DeleteSurfaceDefect]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting the surface defect");
	}
};
